import * as React from "react";
const InnovationIcon = (props) => (
  <svg
    width={37}
    height={37}
    viewBox="0 0 37 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22.2878 21.1133C21.2444 22.2978 19.9739 23.2669 18.544 23.9695V28.0076C18.544 28.3646 18.4016 28.7069 18.1481 28.9593C17.8946 29.2118 17.5509 29.3536 17.1924 29.3536H9.08306C8.72461 29.3536 8.38083 29.2118 8.12737 28.9593C7.8739 28.7069 7.73151 28.3646 7.73151 28.0076V23.9695C4.88336 22.5537 2.70599 20.0824 1.66665 17.086C0.627305 14.0896 0.808818 10.8068 2.17223 7.9421C3.53565 5.07743 5.97232 2.85916 8.95934 1.76334C11.9464 0.667523 15.2457 0.78147 18.1493 2.08073M7.73151 36.0002H18.544"
      stroke="url(#paint0_linear_2492_12817)"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.5556 10.2481C18.6068 10.0839 18.6068 8.72711 19.5556 8.5629C21.2355 8.27172 22.7903 7.48891 24.0218 6.31427C25.2533 5.13964 26.1056 3.62639 26.4702 1.96745L26.5269 1.70364C26.7324 0.769505 28.0677 0.764121 28.2812 1.69556L28.3515 1.99976C28.7301 3.65118 29.5901 5.15441 30.8237 6.32065C32.0573 7.48689 33.6093 8.26415 35.285 8.55482C36.2392 8.72173 36.2392 10.0839 35.285 10.2508C33.6098 10.542 32.0584 11.3194 30.8253 12.4856C29.5923 13.6518 28.7326 15.1548 28.3542 16.8059L28.2839 17.1101C28.0704 18.0415 26.7351 18.0361 26.5296 17.102L26.4756 16.8409C26.1107 15.1812 25.2575 13.6674 24.025 12.4927C22.7925 11.318 21.2365 10.5383 19.5556 10.2481Z"
      stroke="url(#paint1_linear_2492_12817)"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2492_12817"
        x1={11.6439}
        y1={1.0166}
        x2={11.6439}
        y2={36.0002}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD702" />
        <stop offset={0.296875} stopColor="#FFD702" stopOpacity={0.59375} />
        <stop offset={1} stopColor="#FFD702" stopOpacity={0.12} />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2492_12817"
        x1={27.4223}
        y1={1}
        x2={27.4223}
        y2={17.8056}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD702" />
        <stop offset={0.296875} stopColor="#FFD702" stopOpacity={0.59375} />
        <stop offset={1} stopColor="#FFD702" stopOpacity={0.12} />
      </linearGradient>
    </defs>
  </svg>
);
export default InnovationIcon;
